export default "__VITE_ASSET__BGmmBjgV__"